import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData} from '../../../Redux/actions/packageActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'


const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({navbutton}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data
    }), shallowEqual)


    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [destination, setDestination] = useState(null)
    const [destinationName, setDestinationName] = useState(null)

    const [thisCart, setThisCart] = useState([])



    useEffect(() => {
      setThisCart(cart)
      
    },[cart,isModalVisible]);




    const saveChanges = () =>{ 
        
      if(user.role == 'admin' || user.role == 'manager'){
        if(destination && destinationName){
          var destform={
            destination: destination,
            destination_name: destinationName,
            status: 'toPack'
          }
          createPack(destform)
        }else{
          message.error('Select Destination')
        }
      }else{
     
        var destform={
          destination: user.branch,
          destination_name: user.branch_name,
          status: 'pending'
        }
        createPack(destform)
      }
    }

    const createPack = (dest) =>{   
      setLoading(true)
      dispatch(createPackage(dest))
      .then(res=>{
        dispatch(clearCart())
        .then(res=>{     
          var requestData ={        
            packageStatus:'toPack'
          }
          dispatch(getPackageData(requestData))
          setLoading(false)
          setIsModalVisible(false)
        })
        
      })
    
    }


        
    const footer = () =>{

      var schema= {
        title: 'Destination',
        key: 'destionation',
        type: 'options',   
        api:'locations', 
        prevent_recursion:true,
      }
      var current={
        id: user.branch
      }
  
      return(
        <div className="cartFooter"> 
    
       
          <Button type="primary" loading={loading} onClick={()=>{saveChanges()}} >
          { user.role == 'admin' || user.role == 'manager' ? 'Create Package': 'Create Request'}
          </Button>   

          { user.role == 'admin' || user.role == 'manager'?
          <div className="destination">
 
            <InputSelect 
              blueprint={schema} 
              mode={'options'} 
              onChange={e=>{setDestination(e) }}
              onChangeName={names=>{setDestinationName(names) }}
              currentItem={current}                
            />
          </div>
          : null}
        </div>
      )
     
    }

    
    const closeModal = (action) =>{
      if(!loading){
     
        setIsModalVisible(false);       
        dispatch(getCart())
      }
    }

    const deleteThis =(id) =>{
      dispatch(deleteCartItem(id))
      .then(res=>{
        dispatch(getCart())
      })
    }

    const changeCartCount = (id,qty) =>{
      var newdata={
        quantity: qty
      }
      
      dispatch(editCartItem(newdata,id))
      
    }

    return(       
      <>
 
      {user ? navbutton?
      <div onClick={()=>{setIsModalVisible(true)}} >Cart</div>
      :
      <div className={"cartButton"}>
        <Button icon={<ShoppingCartOutlined />} onClick={()=>{setIsModalVisible(true); setLoading(false)}} >{`Cart (${cart.length})`}</Button>  

      </div>
      
      :null
      }


      {isModalVisible?  
        <Modal title={'Cart'}  visible={isModalVisible} footer={thisCart.length > 0 ? footer() :false} onCancel={()=>{closeModal()}} >
          <div className="cart-content">
          <List
            className="demo-loadmore-list"   
            itemLayout="horizontal"
            dataSource={thisCart}
            renderItem={item => (
                <List.Item
                  actions={[ 
                    <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                      <DeleteOutlined  />
                    </Button>
                  ]}
                >
                    {console.log(item)}
                    <List.Item.Meta
                      avatar={
                        <ImageChecker                 
                          url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          success={      
                            <img src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`} alt="image"   className={"prodimage"}/>                           
                          }
                          fail= {   <img src={`${process.env.REACT_APP_AWS_S3}logo.jpg`} alt="image"   className={"prodimage"}/>     }
                        />    
                      }
                      title={item.product_name}
                      // description={
                       
                      // }
                    />
          
                  <div className="vertical">
                    <InputNumber min={0} size={'large'} defaultValue={item.quantity} onChange={(e)=>{changeCartCount(item.id,e)}}  />
                    <span>{item.unit}</span>
                  </div>
                </List.Item>
              )}
            />
            
          </div>
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  